import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0243d210"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "withdrawal-container" }
const _hoisted_2 = { class: "withdrawal-wrapper" }
const _hoisted_3 = { class: "withdrawal-reason" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "section-label" }
const _hoisted_7 = { class: "reasons" }
const _hoisted_8 = ["id", "name", "type", "value", "onClick"]
const _hoisted_9 = ["for"]
const _hoisted_10 = {
  key: 0,
  class: "withdrawal-notice"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "회원 탈퇴를 신청하기 전, 아래 내용을 확인하세요", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("p", null, "* 회원 정보는 개인정보 보호처리 방침에 따라 삭제됩니다."),
  /*#__PURE__*/_createElementVNode("p", null, " * 회원 탈퇴 시 서비스 이용이 불가능하며, 재가입 시 제약이 있을 수 있습니다. ")
], -1 /* HOISTED */))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "정말로 회원탈퇴를 진행하시겠습니까?", -1 /* HOISTED */))
const _hoisted_15 = { class: "modal-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "회원탈퇴" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.withdrawalSurvey?.questions, (question) => {
              return (_openBlock(), _createElementBlock("div", {
                key: question.order
              }, [
                (question.answerType === 'text')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode($setup["BaseTextarea"], {
                        id: `textArea${question.order}`,
                        cols: 30,
                        rows: 6,
                        maxlength: question.maxLength,
                        placeholder: question.placeholder,
                        getTextAreaLength: $setup.getTextAreaLength(question.order),
                        onOnInput: ($event: any) => ($setup.updateTextAreaAnswer(question.order, $event)),
                        onOnFocus: ($event: any) => ($setup.focusRadioInput(question.order))
                      }, null, 8 /* PROPS */, ["id", "maxlength", "placeholder", "getTextAreaLength", "onOnInput", "onOnFocus"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("p", _hoisted_6, _toDisplayString(question.title), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "radio-wrapper",
                            key: answer.id
                          }, [
                            _createElementVNode("input", {
                              id: 
                      $setup.getRadioButtonId(question.order, answer.id) ??
                      `radio-${answer.id}`
                    ,
                              class: "input-radio",
                              name: question.title,
                              type: question.answerType,
                              value: answer.id,
                              onClick: ($event: any) => ($setup.onClickRadioButton(answer.id, question))
                            }, null, 8 /* PROPS */, _hoisted_8),
                            _createElementVNode("label", {
                              class: "radio-label",
                              for: 
                      $setup.getRadioButtonId(question.order, answer.id) ??
                      `radio-${answer.id}`
                    
                            }, _toDisplayString(answer.title), 9 /* TEXT, PROPS */, _hoisted_9)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          ($setup.isSurveyFetchedComplete && !$setup.isSurveyQuestionExisted)
            ? (_openBlock(), _createElementBlock("section", _hoisted_10, [..._hoisted_13]))
            : _createCommentVNode("v-if", true)
        ]),
        _createVNode($setup["FooterButton"], {
          title: "동의하고 탈퇴하기",
          disabled: !$setup.withdrawalAvailable,
          onOnClickFooterButton: $setup.onClickFooterButton
        }, null, 8 /* PROPS */, ["disabled"])
      ]),
      ($setup.showWithdrawalConfirmModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 0,
            title: "회원탈퇴",
            okButtonTitle: "확인",
            cancelButtonTitle: "취소",
            onOnClickOkButton: $setup.requestWithdrawal,
            onOnClickCancelButton: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowWithdrawalConfirmModal(false)))
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      ($setup.showWithdrawalSuccessModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 1,
            title: "회원탈퇴",
            okButtonTitle: "확인",
            onOnClickOkButton: $setup.goToLogoutPage
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_15, " 지금까지 " + _toDisplayString($setup.serviceName) + "를 사용해 주셔서 감사합니다. ", 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}